import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

const Breadcrumbs = ({ breadcrumbs }) => (
  <div className='contentHeader__breadcrumbs'>
    <div className='contentHeader__breadcrumbs__item'><Link to='/' /></div>
    {breadcrumbs.length > 0 ? breadcrumbs.map((b, index) =>
            (b.route
                ? <div key={index} className='contentHeader__breadcrumbs__item'>
                  <Link to={b.route}>
                    {b.name}
                  </Link>
                </div>
                : <div key={index} className='contentHeader__breadcrumbs__item'>{b.name}</div>
            )
        ) : null}
  </div>
)

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired
}

export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/molecules/components/Breadcrumbs.js